






























import Reflect from "reflect-metadata";
import { Component, Vue, Prop } from "vue-property-decorator";

import { User } from "@/models/User";
import messageService from "@/services/MessageService";
import session from "@/services/SessionService";

@Component
export default class ValidateUserDialog extends Vue {
  static VALIDATE_SUCCESSFUL = 1;
  static VALIDATE_FAILED = 2;

  @Prop()
  user!: User;

  loading: boolean = false;
  open: boolean = false;

  toggleOpen() {
    this.open = !this.open;
  }

  validateUser() {
    if (this.user) {
      this.loading = true;
      session
        .validateUser(this.user.id)
        .then(response => {
          this.open = false;
          session.update();
          messageService.addMessage({
            id: ValidateUserDialog.VALIDATE_SUCCESSFUL,
            type: "success",
            text: "Se ha forzado la validación del usuario.",
            overrides: true
          });
        })
        .catch(response => {
          this.loading = false;
          this.open = false;
          messageService.addMessage({
            id: ValidateUserDialog.VALIDATE_FAILED,
            type: "error",
            text:
              "No fue posible forzar la validación del usuario. Intente nuevamente.",
            overrides: true
          });
        });
    }
  }
}
